import posthog from 'posthog-js'
import { POSTHOG_API_KEY, POSTHOG_HOST } from '../env'

let posthogInitialized = false
let lastIdentifiedDistinctId: string | null = null

export function initPosthog(): void {
  if (posthogInitialized) return

  const apiKey = POSTHOG_API_KEY
  if (!apiKey) return

  try {
    posthog.init(apiKey, {
      api_host: POSTHOG_HOST ?? 'https://app.posthog.com',
      capture_pageview: 'history_change', // Capture pageviews by default when api changes
      autocapture: true, // Capture clicks, scrolls, etc. by default
      disable_session_recording: true, // Privacy: no video-like recordings, overflows events
    })

    posthogInitialized = true
  } catch {
    // Swallow PostHog init errors so telemetry never crashes the app
  }
}

export function captureEvent(event: string, properties?: Record<string, unknown>): void {
  if (!posthogInitialized) return

  try {
    posthog.capture(event, properties)
  } catch {
    // Ignore capture errors entirely
  }
}

export function identifyUser(distinctId: string): void {
  if (!posthogInitialized) return

  // Avoid repeated identify calls for the same user during a session
  if (lastIdentifiedDistinctId === distinctId) return

  try {
    posthog.identify(distinctId)
    lastIdentifiedDistinctId = distinctId
  } catch {
    // Ignore identify errors entirely
  }
}

export function resetPosthog(): void {
  if (!posthogInitialized) return

  try {
    posthog.reset()
    lastIdentifiedDistinctId = null
  } catch {
    // Ignore reset errors entirely
  }
}
